import { Typography } from "@mui/material";
import { BasicTableRowStyles } from "../../../components/common/Common.styles";
import BorderRow from "../../../components/common/table/BorderRow";
import CellBox from "../../../components/common/table/CellBox";
import DownloadBtn from "../../../components/common/table/DownloadBtn";
import dayjs from "dayjs";
import { CompanyInvoiceFile } from "../../../types/invoiceTypes";


interface Props {
  row: CompanyInvoiceFile;
  showCompanyName: boolean;
}

export default function InvoicesTableRow(props: Props) {
  return (
    <BasicTableRowStyles>
      <CellBox firstCol>
        <Typography>{props.row.invoiceNumber}</Typography>
      </CellBox>
      <CellBox>
        <Typography>{dayjs(props.row.invoiceDate).format("DD.MM.YYYY")}</Typography>
      </CellBox>
      {
        props.showCompanyName &&
        <CellBox firstCol>
          <Typography>{props.row.companyName}</Typography>
        </CellBox>
      }
      <CellBox>
        <DownloadBtn downloadUrl={props.row.downloadUrl} />
      </CellBox>
      <BorderRow />
    </BasicTableRowStyles>
  );
};
